module.exports = {"DIALOG_CONFIRMATION_TITLE":"Xác nhận","DIALOG_CONFIRM_CANCEL_LABEL":"Hủy bỏ","DIALOG_CONFIRM_ACCEPT_LABEL":"Đồng ý"}